// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useFormContext } from "react-hook-form";
import {
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemText
} from '@mui/material';

export default function SelectAreasDesvincular({ areasCompartidasConUsuario, areasSeleccionadas, setAreasSeleccionadas }) {
    const { register } = useFormContext();

    const handleChange = (event) => {
        const { target: { value } } = event;
        setAreasSeleccionadas(typeof value === 'string' ? value.split(',') : value);
    };

    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl
                fullWidth
                required
            >
                <InputLabel id="select-area-label">Área a desvincular</InputLabel>
                <Select
                    name="area"
                    labelId="select-area-label"
                    label="Área a desvincular"
                    id="select-area"
                    value={areasSeleccionadas}
                    multiple
                    {...register("areasSeleccionadas")}
                    options={areasCompartidasConUsuario}
                    onChange={handleChange}
                    renderValue={(selected) => selected.map(id => {
                        const area = areasCompartidasConUsuario.find(a => a.id === id);
                        return area ? area.name : null;
                    }).join(", ")}
                >
                    {areasCompartidasConUsuario.map((area) => (
                        <MenuItem key={area.id} value={area.id}>
                            <Checkbox style={{ color: "#B71234" }} checked={areasSeleccionadas.includes(area.id)} />
                            <ListItemText primary={area.name} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

